// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"453":"6ac13800","777":"6b8cd4e5"}[chunkId] + ".chunk.js";
};